import actions from './actions';

export const profileChangedAction = (id) => ({ type: actions.PROFILE_CHANGED, payload: {id: id} });
export const profileSelector = store => store.profile;
